import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import OverviewItem from "../overview/OverviewItem";

import { HOME_OVERVIEW_ASSETS } from "../../content/home";
import useInView from "../../hooks/useInView";
import { MAIN_ROUTES } from "../../utils/routes";

const Overview = () => {
  const { t } = useTranslation("home");
  const [setRef] = useInView({
    threshold: 0.1,
  });
  const headerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const overviewItems = t("overview.items", { returnObjects: true }).map(
    (item, index) => ({
      ...item,
      ...HOME_OVERVIEW_ASSETS[index],
      children: item.children?.map((child, childIndex) => ({
        ...child,
        ...HOME_OVERVIEW_ASSETS[index].children?.[childIndex],
      })),
    }),
  );

  return (
    <section
      className="relative bg-white py-24"
      id={MAIN_ROUTES.get("OVERVIEW").ID}
      ref={setRef}
    >
      <div className="mx-auto flex max-w-8xl flex-col gap-14 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl" ref={headerRef}>
          <div className="flex flex-col gap-5">
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-sky-600 max-md:text-center">
              {t("overview.subheader")}
            </p>
            <h2 className="text-4xl font-semibold tracking-tight text-slate-900 max-md:text-center sm:text-5xl">
              {t("overview.header")}
            </h2>
            <p className="text-base leading-8 text-slate-600 max-md:text-center sm:text-lg">
              {t("overview.body")}
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-10 lg:flex-row lg:items-start">
          <div className="w-full lg:w-[34%]">
            {overviewItems.map((item, index) => (
              <OverviewItem
                data={item}
                index={index}
                key={item.header}
                setCurrentIndex={setCurrentIndex}
              />
            ))}
          </div>

          <div className="sticky top-20 hidden flex-1 lg:flex">
            <div className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white p-2 shadow-sm">
              <img
                alt={overviewItems[currentIndex].header}
                className="h-auto max-h-[78vh] w-full rounded-xl object-cover"
                src={overviewItems[currentIndex].image}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview;
